import { ReactComponent as DigitalTwinIcon } from "../../../../assets/images/doll_front.svg";
import Button from "../../../../components/button/Button";
import "./DigitalTwinShoertuct.css";

const DigitalTwinShortcut = ({ patientName, onDismiss, onConfirm }) => {
  return (
    <div className="DigitalTwinShortcut">
      <div className="DigitalTwinShortcut-title">
        Do you also want to create <br />
        {patientName}'s Digital Twin?
      </div>
      <div className="DigitalTwinShortcut-image-wrapper">
        <DigitalTwinIcon className="DigitalTwinPlaceholder-icon" />
      </div>
      <div className="DigitalTwinShortcut-navigation-buttons">
        <Button value={"No, Later"} onClick={onDismiss}></Button>
        <Button value={"Yes"} onClick={onConfirm}></Button>
      </div>
    </div>
  );
};
export default DigitalTwinShortcut;
